
// 回溯视频
import { store, mutations } from '@/observable/store'
import { getCookie } from '../commonUtils'
import { getConfirm } from "../../model/api/confirmService.js";
import { getTraceId } from "@/model/javaApi/detail";
import process from "@/views/reservation/process.vue";

let txrwebSrc = ''
function loadJs(url, callback) {
  var script = document.createElement('script');
  script.type = "text/javascript";
  script.id = "txrweb";
  if (typeof (callback) != "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      }
    } else {
      script.onload = function () {
        callback();
      }
    }
  }
  script.src = url;
  document.body.appendChild(script);
}


/**
 * 生产：https://txwr-api.cloud-ins.cn
 * 测试：https://recall-api.ikandy.cn
 * @type {string}
 */
let txrWebServerURL = ''

if (process.env.VUE_APP_CURRENTMODE === 'production') {
  //腾讯云生产环境sdk https://retrospective-demo.cloud-ins.cn/static/js/txrweb.1.0.1.min.js
  // 存储到新氧服务器的生产环境sdk： https://static.soyoung.com/sy-pre/txrwebprod.1.0.1.min-1600855800710.js
  // txrwebSrc = "https://retrospective-demo.cloud-ins.cn/static/js/txrweb.1.0.1.min.js"
  // txrwebSrc = "https://recall-sync.cloud-ins.cn/record/sdk/txrweb.min.js"
  // txrWebServerURL = 'https://txwr-api.cloud-ins.cn'
  txrwebSrc = "https://cdn.minishine.cn/record/txrweb.min.js"
  txrWebServerURL = 'https://trace.minishine.cn'

} else {
  // https://recall-demo.cloud-ins.cn/static/js/txrweb.1.0.1.min.js
  // https://recall-demo.cloud-ins.cn/static/js/txrweb.1.0.13.min.js
  // txrwebSrc = "https://recall-demo.cloud-ins.cn/sdk/txrweb.min.js"
  // txrwebSrc = "https://recall-sync.cloud-ins.cn/record/sdk/txrweb.min.js"
  txrwebSrc = "https://cdn.minishine.cn/record/txrweb.min.js"
  txrWebServerURL = 'https://recall-api.ikandy.cn'

}







const privateConfig = JSON.parse(process.env.VUE_APP_TX_CONFIG)
const versionConfig = {
  '/details': '1.1.0',
  '/detailsA': '1.1.1',
  '/teeth': '1.1.1',
  '/reservationServe': '1.1.1',
  '/documentary': '1.1.1',
  '/safeguard': '1.1.2',
  '/insuranceDraw': '1.1.0',
  '/stencilInsurance':'1.2.0',
  '/insuranceInfo':'1.2.0',
  // ---
  '/stencilDetial':'1.3.0',
  '/detailInfo':'1.3.0',
  '/detailPay':'1.3.0'
}


export default {
  methods: {
    //获取 privateKey
    getPrivateKey(){
      if(this.$route.path == '/stencilDetial' || this.$route.path == '/detailInfo' || this.$route.path == '/detailPay'){
        const temp = 'ht_irok_plus' // 模板写死是这一款保险 后期从后台取
        return `${privateConfig[temp].prodId}&${privateConfig[temp].prodKey}`
      }else{
        return `${privateConfig[store.refid.product_id].prodId}&${privateConfig[store.refid.product_id].prodKey}`
      }
    },
    // 保证加载成功 txrweb.js
    loadTX(fn) {
      if (document.getElementById("txrweb")) {
        fn()
      } else {
        loadJs(txrwebSrc, () => {
          fn()
        });
      }
    },
    // 回溯弹框得到bizKey 时调用
    getbizKey(bizKey) {
      this.loadTX(() => { this.postTX(bizKey, versionConfig[this.$route.path]) })
    },
    // 从query中拿到参数存储
    querySetTX() {
      if (this.$route.query.TXbizKey && this.$route.query.TXversion) {
        const data = {
          bizKey: this.$route.query.TXbizKey,
          version: this.$route.query.TXversion
        }
        console.log('setTXbizKey',data)
        mutations.setTXoption(data);
      }
    },
    // 调用视频开始录制API
    postTX(bizKey = '', version) {
      if(!bizKey){
        getTraceId().then((data) =>{
          this.getbizKey(data)
        })

      }else{
        console.log('=======================================')
        console.log('视频录制开始起点')
        console.log(window.instance, 'window.instance')
        mutations.setTXoption({ bizKey, version });
        const _this = this;
        const privateKey = this.getPrivateKey()
        const postData = {
          privateKey: privateKey,
          version: version,
          forceStart: true,
          bizKey: store.TXoption.bizKey,
          serverURL: txrWebServerURL
        }
        const data = {
          privateKey: privateKey,
          version: version,
          forceStart: true,
          bizKey: store.TXoption.bizKey,
          serverURL: txrWebServerURL,
          success: () => {
            _this.STATISTICS_CONFIG.insur_recall_new_click({"ex":{postData:JSON.stringify(postData) }}) //创建回溯单成功
            console.log('***********录制起点初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********录制起点初始化参数****************')
            console.log('***********录制起点cookie****************')
            console.log(getCookie())
            console.log('***********录制起点cookie****************')
          },
          error:(err) =>{
            _this.STATISTICS_CONFIG.insur_recall_new_fail_click({"ex":{errmsg:JSON.stringify(err),postData:JSON.stringify(postData) }}) //创建回溯单失败
          }
        }
        let errmsg = ''
        try {
          if (window.instance) {
            _this.stopTX(() => {
              window.instance = new txrweb(data)
            })
          } else {
            window.instance = new txrweb(data)
          }
        }
        catch(err) {
          errmsg = err.message
        }
        finally {
          // 创建回溯单埋点
          _this.STATISTICS_CONFIG.insur_recall_initialize_click({"ex":{postData:JSON.stringify(postData),tx:typeof(txrweb),errmsg:errmsg}})
        }
      }

    },
    // 更新投保人信息
    updataTX(tbparams, orderNo , bbparams = {}) {

      this.STATISTICS_CONFIG.insur_recall_submit_click({"ex":{orderNo:orderNo,tbName:tbparams.name}})
      console.log('***********同步投保人信息****************')
      const data = {
        orderNo: orderNo, //订单号
        tbName: tbparams.name, // 投保⼈姓名
        tbId: tbparams.idcard,// 投保⼈id
        bbName: bbparams.name || '', // 被保⼈姓名
        bbId: bbparams.idcard || ''// 被保⼈id
      }
      const _this = this;
      window.instance.updateBiz(data).then(() => {
        _this.STATISTICS_CONFIG.insur_recall_update_click({"ex":{orderNo:data.orderNo,tbName:data.tbName}})
        console.log(data);
        console.log('***********同步投保人信息****************')
      });
    },
    // 填写信息页
    infoTX() {
      this.loadTX(() => {
        if (!window.instance){
          getConfirm(store.refid.product_id).then((data) =>{
            this.getbizKey(data.traceback)
          })
        }else{
          const data = {
            privateKey: this.getPrivateKey(),
            version: store.TXoption.version,
            bizKey: store.TXoption.bizKey,
            forceStart: false,
            serverURL: txrWebServerURL,
            success: () => {
              console.log('***********填写信息初始化参数****************')
              console.log(`privateKey=${data.privateKey}`)
              console.log(`version=${data.version}`)
              console.log(`forceStart=${data.forceStart}`)
              console.log(`bizKey=${data.bizKey}`)
              console.log(`serverURL=${data.serverURL}`)
              console.log('***********填写信息始化参数****************')
              console.log('***********填写信息cookie****************')
              console.log(getCookie())
              console.log('***********填写信息cookie****************')
            }
          }
          window.instance = new txrweb(data);
        }

      })
    },
    // 重要信息确认
    confirmedTX() {
      this.loadTX(() => {
          const data = {
            privateKey: this.getPrivateKey(),
            version: store.TXoption.version,
            bizKey: store.TXoption.bizKey,
            forceStart: false,
            serverURL: txrWebServerURL,
            success: () => {
              console.log('***********重要信息确认页初始化参数****************')
              console.log(`privateKey=${data.privateKey}`)
              console.log(`version=${data.version}`)
              console.log(`forceStart=${data.forceStart}`)
              console.log(`bizKey=${data.bizKey}`)
              console.log(`serverURL=${data.serverURL}`)
              console.log('***********重要信息确认页始化参数****************')
              console.log('***********重要信息确认页cookie****************')
              console.log(getCookie())
              console.log('***********重要信息确认页cookie****************')
            }
          }
          window.instance = new txrweb(data);
      })
    },
    // 收银台
    payTX() {
      this.loadTX(() => {
        const data = {
          privateKey: this.getPrivateKey(),
          version: store.TXoption.version,
          bizKey: store.TXoption.bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********收银台初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********收银台初始化参数****************')
            console.log('***********收银台cookie****************')
            console.log(getCookie())
            console.log('***********收银台cookie****************')
          }
        }
        window.instance = new txrweb(data);
      })
    },
    // 操作结果确认
    payResultTX() {
      this.loadTX(() => {
        const data = {
          privateKey: this.getPrivateKey(),
          version: store.TXoption.version,
          bizKey: store.TXoption.bizKey,
          pageTitle:'操作结果确认',
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********操作结果确认参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********操作结果确认化参数****************')
            console.log('***********操作结果确认cookie****************')
            console.log(getCookie())
            console.log('***********操作结果确认cookie****************')
          }
        }
        window.instance = new txrweb(data);
      })
    },
    // 操作成功
    operatingTX(callback) {
      this.loadTX(() => {
        //ios支付成功回调时会新打开webview 支付成功页的版本号与bizkey会存在地址栏中
        const version = store.TXoption.version;
        const bizKey = store.TXoption.bizKey;
        const data = {
          privateKey: this.getPrivateKey(),
          version: version,
          bizKey: bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********操作成功初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********操作成功初始化参数****************')
            console.log('***********操作成功cookie****************')
            console.log(getCookie())
            console.log('***********操作成功cookie****************')
            /** 提供回调入口，配合调用后端接口验证支付状态 */
            if (typeof callback === 'function') {
              callback()
            }
          }
        }
          window.instance = new txrweb(data);

      })

    },
    // 支付成功
    finishTX(callback) {
      this.loadTX(() => {
        //ios支付成功回调时会新打开webview 支付成功页的版本号与bizkey会存在地址栏中
        const version = store.TXoption.version;
        const bizKey = store.TXoption.bizKey;
        const data = {
          privateKey: this.getPrivateKey(),
          version: version,
          bizKey: bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********支付成功初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********支付成功初始化参数****************')
            console.log('***********支付成功cookie****************')
            console.log(getCookie())
            console.log('***********支付成功cookie****************')
            /** 提供回调入口，配合调用后端接口验证支付状态 */
            if (typeof callback === 'function') {
              callback()
            }
          }
        }
        window.instance = new txrweb(data);
        // 不可以直接调用，需要和后端协作
        // this.stopTX()
      })

    },
    // 领取成功
    receiveTX() {
      this.loadTX(() => {
        window.instance = new txrweb({
          privateKey: this.getPrivateKey(),
          version: store.TXoption.version || '1.0.2',
          pageTitle: '领取成功',
          bizKey: store.TXoption.bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********领取成功初始化参数****************')
            console.log(`version=${store.TXoption.version || '1.0.2'}`)
            console.log(`bizKey=${store.TXoption.bizKey}`)
            console.log(`serverURL=${txrWebServerURL}`)
            console.log('***********领取成功初始化参数****************')
            console.log('***********领取成功cookie****************')
            console.log(getCookie())
            console.log('***********领取成功cookie****************')
          }
        });
        // 由后端发起关闭逻辑，当前页面发起，不涉及支付跳转
        // this.stopTX()
      })


    },
    // 预约成功
    subscribeTX() {
      this.loadTX(() => {
        window.instance = new txrweb({
          privateKey: this.getPrivateKey(),
          version: store.TXoption.version || '1.0.1',
          pageTitle: '预约成功',
          bizKey: store.TXoption.bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********预约成功初始化参数****************')
            console.log(`version=${store.TXoption.version || '1.0.1'}`)
            console.log(`bizKey=${store.TXoption.bizKey}`)
            console.log(`serverURL=${txrWebServerURL}`)
            console.log('***********预约成功初始化参数****************')
            console.log('***********预约成功cookie****************')
            console.log(getCookie())
            console.log('***********预约成功cookie****************')
          }
        });
        // 由后端发起关闭逻辑，当前页面发起，不涉及支付跳转
        // this.stopTX()
      })
    },
    // 调用txrweb的停止录制方法
    stopTX(callback) {
      const _this = this;
      /** 前端发起停止录制回溯 */
      if (window.instance) {
        console.log('发起停止录制视频')
        window.instance.stopBiz().then(() => {
          window.instance = null
          _this.STATISTICS_CONFIG.insur_recall_stop_click()
          console.log('发起停止录制视频接口回调触发')
          console.log('前端发起业务完成')
          console.log('=======================================')
          if (callback) {
            callback()
          }
        });
      } else {
        console.log('未初始化instance实例')
        if (callback) {
          callback()
        }
      }
    }
  },
}
